import React, { useEffect, useState } from 'react';
import './IntroLoader.css';
import { Box } from '@mui/material';
import Logo from './assets/logo2.svg';
import coupleImg from './assets/images/couple.png';
import womanImg from './assets/images/single2.png';
import manImg from './assets/images/single.png';


export default function IntroLoader({ onFinish }) {
  const [visible, setVisible] = useState(true);
  const [showContent, setShowContent] = useState(false);
  const [fadeInContent, setFadeInContent] = useState(false);
  const [animatedColor] = useState('#EFF0DE');

  useEffect(() => {
    // Show blue screen for 0.4s, then show content
    const showContentTimer = setTimeout(() => setShowContent(true), 400);
    // Fade in content after blue
    const fadeInTimer = setTimeout(() => setFadeInContent(true), 450);
    // Fade out after 1.7s total (blue + content)
    const fadeOutTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onFinish && onFinish(), 700); // match fade duration
    }, 1700);
    return () => {
      clearTimeout(showContentTimer);
      clearTimeout(fadeInTimer);
      clearTimeout(fadeOutTimer);
    };
  }, [onFinish]);

  return (
    <div className={`hero intro-loader${visible ? '' : ' fade-out'}`} style={{ background: '#102A41' }}>

      <div className={`intro-content${showContent ? ' show' : ''}${fadeInContent ? ' fade-in' : ''}`}>
        {/* Title and Progress Bar */}
        <div style={{
          width: '100%',
          maxWidth: 360,
          margin: '0 auto',
          marginTop: 32,
          marginBottom: 24,
          textAlign: 'left',
          zIndex: 5,
          position: 'absolute',
          top: "10px",
          left: "0",
          
        }}>
          <div style={{
            fontFamily: 'OCHighwayVAR2Heading, serif',
            fontWeight: 700,
            fontSize: '1.5rem',
            color: animatedColor,
            marginBottom: 10,
            letterSpacing: '-1px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            gap: 0,
            transition: 'color 0.6s cubic-bezier(.4,0,.2,1)'
          }}>
            Calculando riesgo de apnea
          </div>
        </div>
        <ul className="float-set">
          <li style={{
            '--x-start': '-20vw', '--x-end': '5vw', '--y': '16vh', '--d': '7s'
          }}>
            <img src={manImg} alt="Middle-aged man enjoying life" />  
          </li>
          <li style={{
            '--x-start': '10vw', '--x-end': '-55vw', '--y': '36vh', '--d': '8s'
          }}>
            <img src={womanImg} alt="Middle-aged woman enjoying life" />
          </li>
          <li style={{
            '--x-start': '-45vw', '--x-end': '10vw', '--y': '58vh', '--d': '9s'
          }}>
            <img src={coupleImg} alt="Middle-aged couple enjoying life" />
          </li>
        </ul>
        <Box className="brand intro-logo" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
          <img src={Logo} alt="Buno logo" style={{ width: 100, height: 'auto', display: 'block' }} />
        </Box>
      </div>
    </div>
  );
}
